import * as React from "react";
import PackageComparisonHeader from "./package-comparison-header";
import PackageComparisonExpandableElement from "./package-comparison-expandable-element";
import styled from "styled-components";

interface PackageComparisonBlockProps {}

interface PackageComparisonBlockState {}

class PackageComparisonBlock extends React.Component<PackageComparisonBlockProps,PackageComparisonBlockState> {

  render() {
    return (
      <div className="materialize-theme-styles">
        <PackageComparisonBlockWrapper>
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <div className="panel-group feature-accordion brand-accordion icon angle-icon" id="basic">

                  <PackageComparisonHeader/>
                  <PackageComparisonExpandableElement
                    appModuleName="Moduł Fakturowy"
                    appModuleElements={[
                      {
                        elementName: "Faktury sprzedaży z VAT i bez VAT",
                        elementIsFree: true
                      },
                      {
                        elementName: "Faktury pro forma",
                        elementIsFree: true
                      },
                      {
                        elementName: "Faktury na podstawie pro formy",
                        elementIsFree: true
                      },
                      {
                        elementName: "Faktury korygujące",
                        elementIsFree: true
                      },
                      {
                        elementName: "Własne logo na fakturze",
                        elementIsFree: true
                      },
                      {
                        elementName: "Wiele schematów numeracji faktur",
                        elementIsFree: true
                      },
                      {
                        elementName: "Własna numeracja faktur",
                        elementIsFree: true
                      },
                      {
                        elementName: "Wysyłanie faktur e-mailem",
                        elementIsFree: true
                      },
                      {
                        elementName: "Eksportowanie faktur w różnych formatach",
                        elementIsFree: true
                      },
                      {
                        elementName: "Faktury w języku angielskim",
                        elementIsFree: true
                      },
                      {
                        elementName: "Faktury w różnych walutach",
                        elementIsFree: true
                      },
                      {
                        elementName: "Kilka szablonów faktur",
                        elementIsFree: true
                      },
                      {
                        elementName: "Zapisywanie produktów",
                        elementIsFree: true
                      },
                      {
                        elementName: "Zbiorcze pobieranie faktur",
                        elementIsFree: true
                      },
                      {
                        elementName: "Integracja z GUS",
                        elementIsFree: true
                      },
                      {
                        elementName: "Integracja z KSeF",
                        elementIsFree: true
                      },
                      {
                        elementName: "Wiele rachunków bankowych",
                        elementIsFree: true
                      },
                    ]}
                  />
                  <PackageComparisonExpandableElement
                    appModuleName="Moduł CRM"
                    appModuleElements={[
                      {
                        elementName: "Katalog kontrahentów",
                        elementIsFree: true
                      },
                      {
                        elementName: "Import kontrahentów z GUS",
                        elementIsFree: true
                      },
                      {
                        elementName: "Zaawansowane ustawienia kontrahentów",
                        elementIsFree: true
                      },
                    ]}
                  />
                  <PackageComparisonExpandableElement
                    appModuleName="Moduł Księgowość"
                    appModuleElements={[
                      {
                        elementName: "Polityka rachunkowości",
                        elementIsFree: false
                      },
                      {
                        elementName: "Plan kont",
                        elementIsFree: false
                      },
                      {
                        elementName: "Dziennik",
                        elementIsFree: false
                      },
                      {
                        elementName: "Księga główna",
                        elementIsFree: false
                      },
                      {
                        elementName: "Księga pomocnicza",
                        elementIsFree: false
                      },
                      {
                        elementName: "Zestaw. obr. i sald księgi głównej",
                        elementIsFree: false
                      },
                      {
                        elementName: "Zestaw. obr. i sald księgi pomocniczej",
                        elementIsFree: false
                      },
                      {
                        elementName: "Schematy księgowania przychodów",
                        elementIsFree: false
                      },
                      {
                        elementName: "Schematy księgowania kosztów",
                        elementIsFree: false
                      },
                      {
                        elementName: "Deklaracje VAT",
                        elementIsFree: false
                      },
                      {
                        elementName: "Rejestry VAT sprzedaży",
                        elementIsFree: false
                      },
                      {
                        elementName: "Rejestry VAT zakupu",
                        elementIsFree: false
                      },
                      {
                        elementName: "JPK_V7",
                        elementIsFree: false
                      },
                      {
                        elementName: "JPK_KR",
                        elementIsFree: false
                      },
                      {
                        elementName: "JPK_FA",
                        elementIsFree: false
                      },
                      {
                        elementName: "Potwierdzenia sald kontrahentów",
                        elementIsFree: false
                      },
                      {
                        elementName: "Automatyczne rozliczenie WNT",
                        elementIsFree: false
                      },
                      {
                        elementName: "Automatyczne rozliczenie Importu Usług",
                        elementIsFree: false
                      },
                      {
                        elementName: "Metoda kasowa VAT",
                        elementIsFree: false
                      },
                      {
                        elementName: "Księgowość podmiotów zwolnionych z VAT",
                        elementIsFree: false
                      },
                      {
                        elementName: "Zaliczki CIT",
                        elementIsFree: false
                      },
                      {
                        elementName: "Rejestry CIT",
                        elementIsFree: false
                      },
                      {
                        elementName: "Deklaracje CIT",
                        elementIsFree: false
                      },
                      {
                        elementName: "Środki Trwałe",
                        elementIsFree: false
                      },
                      {
                        elementName: "Sprawozdania finansowe",
                        elementIsFree: false
                      },
                      {
                        elementName: "Uchwały do sprawozdania finansowego",
                        elementIsFree: false
                      },
                      {
                        elementName: "Kalendarz z przypomnieniami",
                        elementIsFree: false
                      },
                      {
                        elementName: "Wysyłanie JPK i eDeklaracji",
                        elementIsFree: false
                      },
                      {
                        elementName: "Rozrachunki z kontrahentami",
                        elementIsFree: false
                      },
                    ]}
                  />
                  <PackageComparisonExpandableElement
                    appModuleName="Moduł Kadrowy"
                    appModuleElements={[
                      {
                        elementName: "Rejestr osobowy",
                        elementIsFree: false
                      },
                      {
                        elementName: "Rozliczanie umów o pracę",
                        elementIsFree: false
                      },
                      {
                        elementName: "Rozliczanie umów zlecenia",
                        elementIsFree: false
                      },
                      {
                        elementName: "Rozliczanie umów o dzieło",
                        elementIsFree: false
                      },
                      {
                        elementName: "Rozliczanie licencji",
                        elementIsFree: false
                      },
                      {
                        elementName: "Rozliczanie aktów powołania",
                        elementIsFree: false
                      },
                      {
                        elementName: "Rozliczanie świadczeń niepieniężnych",
                        elementIsFree: false
                      },
                      {
                        elementName: "Rozliczanie praktyk absolwenckich",
                        elementIsFree: false
                      },
                      {
                        elementName: "Rozliczania ryczałtowe",
                        elementIsFree: false
                      },
                      {
                        elementName: "Listy płac",
                        elementIsFree: false
                      },
                      {
                        elementName: "Deklaracja PIT-11",
                        elementIsFree: false
                      },
                      {
                        elementName: "Deklaracja PIT-4R",
                        elementIsFree: false
                      },
                      {
                        elementName: "Deklaracja ZUS DRA",
                        elementIsFree: false
                      },
                      {
                        elementName: "Deklaracja ZUS RCA",
                        elementIsFree: false
                      },
                      {
                        elementName: "Deklaracja ZUS RZA",
                        elementIsFree: false
                      },
                      {
                        elementName: "Deklaracja ZUS ZUA",
                        elementIsFree: false
                      },
                      {
                        elementName: "Deklaracja ZUS ZPA",
                        elementIsFree: false
                      },
                    ]}
                  />
                  <PackageComparisonExpandableElement
                    appModuleName="Analizy finansowe"
                    appModuleElements={[
                      {
                        elementName: "Wykresy przychodów i kosztów",
                        elementIsFree: false
                      },
                      {
                        elementName: "Prognozy podatkowe",
                        elementIsFree: false
                      }
                    ]}
                  />
                  <PackageComparisonExpandableElement
                    appModuleName="Bezpieczeństwo danych"
                    appModuleElements={[
                      {
                        elementName: "Aktualizacje aplikacji",
                        elementIsFree: true
                      },
                      {
                        elementName: "Kopie zapasowe baz danych",
                        elementIsFree: true
                      },
                      {
                        elementName: "Zabezpieczona transmisja danych",
                        elementIsFree: true
                      },
                    ]}
                  />
                  <PackageComparisonExpandableElement
                    appModuleName="Pozostałe funkcje"
                    appModuleElements={[
                      {
                        elementName: "Wsparcie księgowe",
                        elementIsFree: false
                      },
                      {
                        elementName: "Wsparcie techniczne",
                        elementIsFree: true
                      },
                      {
                        elementName: "Konta użytkowników",
                        elementIsFree: true
                      },
                      {
                        elementName: "Nadawanie przywilejów nowym użytkownikom",
                        elementIsFree: true
                      },
                      {
                        elementName: "Wiele firm jednego użytkownika",
                        elementIsFree: true
                      },
                    ]}
                  />

                </div>
              </div>
            </div>
          </div>
        </PackageComparisonBlockWrapper>
      </div>
    )
  }

}

/** STYLES */

const PackageComparisonBlockWrapper = styled.section`
  padding-top: 110px;
  padding-bottom: 40px;
`;

export default PackageComparisonBlock


// WEBPACK FOOTER //
// ./src/layouts/package-comparison-block/package-comparison-block.tsx